import * as Yup from 'yup';
import { AdminAllowanceNames, ContractTypes } from '@pharmaplan/common';
import strings from '../../../localization';
import { commonAllowanceValidations, hourlyRateValidator, longTermContractValidation } from '../../../helpers/commonValidators';

export const SelfExpressBookingValidator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    ...longTermContractValidation,
    pharmacyId: Yup.string().required(strings.requiredField).nullable(),
    pharmacistId: Yup.string().required(strings.requiredField).nullable(),
    [AdminAllowanceNames.pharmacistHourlyRate]:
     Yup.string().nullable().when('contractType', {
       is: ContractTypes.shortTerm,
       then: hourlyRateValidator,
     }),
    startTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    endTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    selectedDate: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
  });

const Validator = () =>
  Yup.object().shape({
    ...commonAllowanceValidations,
    pharmacyWeekDayHourlyRate: Yup.number().nullable().when(['contractType', 'weekdayHours'], {
      is: (contractType: ContractTypes, weekdayHours: number) =>
        contractType === ContractTypes.longTerm && weekdayHours > 0,
      then: hourlyRateValidator,
    }),
    pharmacyWeekendHourlyRate: Yup.number().nullable().when(['contractType', 'weekendHours'], {
      is: (contractType: ContractTypes, weekendHours: number) =>
        contractType === ContractTypes.longTerm && weekendHours > 0,
      then: hourlyRateValidator,
    }),
    ...longTermContractValidation,
    pharmacyId: Yup.string().required(strings.requiredField).nullable(),
    pharmacistId: Yup.string().required(strings.requiredField).nullable(),
    [AdminAllowanceNames.pharmacistHourlyRate]: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
    [AdminAllowanceNames.pharmacyHourlyRate]: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: hourlyRateValidator,
    }),
    startTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    endTime: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
    selectedDate: Yup.string().nullable().when('contractType', {
      is: ContractTypes.shortTerm,
      then: () =>
        Yup.string().required(strings.requiredField),
    }),
  });

export default Validator;
